/** Найбільший розмір файлу запису (UIUX field-types/file: 25 МБ, налаштовується) — більші файли не надсилаються. */
export const MAX_FILE_MB = 25;

/** Файли, що завеликі для завантаження, і ті, що можна надіслати. Чиста функція. */
export function splitBySize<T extends { size: number }>(files: readonly T[], maxMb = MAX_FILE_MB): { ok: T[]; tooBig: T[] } {
  const limit = maxMb * 1024 * 1024;
  return { ok: files.filter((f) => f.size <= limit), tooBig: files.filter((f) => f.size > limit) };
}

/** Розмір файлу як у прототипі: «178 КБ» (щонайменше 1 КБ) або «2.4 МБ». Чиста функція. */
export function fileSizeLabel(bytes: number, kb: string, mb: string): string {
  const k = bytes / 1024;
  return k < 1024 ? `${Math.max(1, Math.round(k))} ${kb}` : `${(k / 1024).toFixed(1)} ${mb}`;
}
